import home from "assets/images/home_icon.svg";
import explore from "assets/images/explore_icon.svg";
import insight from "assets/images/insights_icon.svg";
import profile from "assets/images/profile.png";
import shop from "assets/images/shop_icon.svg";
import track from "assets/images/track.png";
import shopActive from "assets/images/shop_active_icon.svg";
import trackDesktop from "assets/images/track_desktop_icon.svg";
import trackDesktopActive from "assets/images/track_desktop_active_icon.svg";
import homeActive from "assets/images/home_active_icon.svg";
import exploreActive from "assets/images/explore_active_icon.svg";
import insightActive from "assets/images/insights_active_icon.svg";
import profileActive from "assets/images/profile_active.png";
import coachingFeature from "assets/images/coaching_feature_v2.svg";
import trackFeature from "assets/images/track_feature.svg";
import gainFeature from "assets/images/gain_feature.svg";
import learnFeature from "assets/images/learn_feature.svg";
import exploreAll from "assets/images/explore_all.png";
import learn from "assets/images/learn.png";
import product from "assets/images/product.png";
import guidance from "assets/images/guidance.png";
import { required } from "@/helpers/form-validator.helper";

export const menuItems = {
  HOME: {
    enabled: true,
    key: "home",
    value: "Home",
    to: "home",
    icon: home,
    iconActive: homeActive,
  },
  INSIGHTS: {
    enabled: true,
    key: "insights",
    value: "Insights",
    to: "insights",
    icon: insight,
    iconActive: insightActive,
  },
  TRACK: {
    enabled: true,
    key: "track",
    value: "Track",
    to: "track",
    icon: trackDesktop,
    iconMobile: track,
    iconActive: trackDesktopActive,
  },
  EXPLORE: {
    enabled: true,
    key: "explore",
    value: "Explore",
    to: "explore",
    icon: explore,
    iconActive: exploreActive,
    menuItems: [
      {
        key: "exploreAll",
        value: "Explore All",
        icon: exploreAll,
        to: "/explore",
      },
      {
        key: "learn",
        value: "Learn",
        icon: learn,
        to: "/explore/learn",
      },
      {
        key: "get-guidance",
        icon: guidance,
        value: "Get Guidance",
        to: "/explore/get-guidance/module",
      },
      {
        key: "product",
        value: "Products",
        icon: product,
        to: "/explore/product",
        // to: "",
      },
    ],
  },
  PROFILE: {
    enabled: false,
    key: "profile",
    value: "Profile",
    to: "profile",
    icon: profile,
    iconActive: profileActive,
  },
  PRODUCTS: {
    enabled: true,
    key: "shop",
    value: "Shop",
    to: "/explore/product",
    icon: shop,
    iconActive: shopActive,
  },
};

export const ID_HUB_REGISTER_URL = import.meta.env.VITE_REGISTRATION_URL;
export const BUY_NOW_URL =
  "https://www.canesten.co.uk/discover-canesten-products";
export const LEARN_MORE =
  "https://www.canesten.co.uk/discover-canesten-products";
export const IMPRINT_URL = "https://www.canesten.co.uk/imprint";
export const HELP_CONTACT_URL = "https://www.canesten.co.uk/contact";
export const PREFERENCE_CENTER =
  "https://privacyportaluatde.onetrust.com/ui/#/preferences/multipage/token/c0773a4b-beb3-4c09-92d2-0b2b88b6e102";
export const DELETE_ACCOUNT = import.meta.env.VITE_DELETE_ACCOUNT;
export const CHANGE_PASSWORD = import.meta.env.VITE_CHANGE_PASSWORD;
export const ENTER_KEY_CODE = 13;
export const YOUR_COACH_PARAM = "your-coach";
export const ENVIRONMENTS = {
  PROD: "app.canesmeno.co.uk",
  LOCAL: "localhost",
};
export const ASSESSMENT_TABS = {
  INTRO: "intro",
  QUESTIONARE: "questionare",
  ABOUT: "about",
  ABOUT_RESPONSE: "about_response",
};

export const GRAPH_TYPE = {
  BAR_CHART: "bar",
  LINE_CHART: "line",
};
export const INSIGHTS_TABS = [
  { title: "Weekly", days: 7 },
  { title: "Monthly", days: 28 },
  // { title: "6 months", days: 180 },
  // { title: "Yearly", days: 365 },
];

export const RESULTS_CAROUSEL_HEADINGS = {
  heading: "The Truth Behind Menopause",
  description:
    "The period around your last menstrual cycle brings with it specific changes and feelings. Find out more here.",
};

export const MENOPAUSE_STAGES = {
  PREMENOPAUSE: "Premenopause",
  PERIMENOPAUSE: "Perimenopause",
  EARLY_MENOPAUSE: "Early Menopause",
  MENOPAUSE: "Menopause",
  POSTMENOPAUSE: "Postmenopause",
};

export const MANDATORY_CONSENT = {
  id: "canesmeno_data_usage",
  message:
    "Without your consent, access to the CanesMeno® Guide will be restricted, as it requires personal data input.",
};

export const CONSENT_KEY = "consent";
// export const MQ6_SKIPPED = "mq6_skipped";
export const UPLOAD_SKIPPED = "upload_skipped";
export const IPHONE_SPECIFIC_IOS_TOKEN = "FCMtoken";
export const ONBOARDING_DONE = "onboarding_done";
export const EXISTING_USER = "existing_user";

export const CACHE_KEY = {
  HOME_INSIGHTS: "insightsData",
  PRODUCTS: "products",
  ARTICLES: "articles",
  ARTICLES_QUERY_KEYS: {
    ALL: "all-articles",
    GUIDANCE_ALL: "article-guidance-all",
    GUIDANCE_BY_CATEGORY: "guidance-articles-by-category",
    GUIDANCE_CATEGORIES: "guidance-categories",
    LEARN_BY_CATEGORY: "learn-articles-by-category",
    LEARN_BY_ID: "learn-article-by-id",
    LEARN_CATEGORIES: "learn-categories",
    INSIGHTS: "insights-articles",
  },
  PROFILE_QUERY_KEYS: {
    PROFILE_DETAILS: "profile-details",
  },
};

export const WELCOME_FOOTER_SECTION_CONTENT = {
  DESCRIPTION: `<p>The CanesMeno Hub is bought to you by the makers of Canesten®, the UK and Ireland's no.1 selling women's intimate health brand*.</p>
<p>With over 40 years of scientific knowledge, research, product innovation and clinical expertise, Canesten® has helped people around the world understand, treat and prevent their intimate health conditions.</p>
<p>Our brand mission is to help empower more women to take control of their intimate health and to help break down the social barriers surrounding women's health.</p>`,
  SUB_DESCRIPTION: `<p>
                *IRI unit sales data including Thrush, Bacterial Vaginosis,
                Cystitis and Vaginal Dryness segments. To verify contact <a href="mailto:consumerhealthuk@bayer.com">consumerhealthuk@bayer.com</a><br />
                IQVIA MAT May 2025. To verify, please contact <a href="mailto:info.ireland@bayer.com">info.ireland@bayer.com</a>
              </p>`,
};

export const LOGIN_ERROR = "Error occurred while logging in. Please try again.";

export const PRODUCT_LEARN_MORE = [
  {
    title: "night",
    url: "https://www.canesten.co.uk/discover-canesten-products/canesmeno-night",
  },
  {
    title: "multi support",
    url: "https://www.canesten.co.uk/discover-canesten-products/canesmeno-multi-support",
  },
  {
    title: "hydration & comfort gel",
    url: "https://www.canesten.co.uk/discover-canesten-products/canesmeno-hydration-comfort-gel",
  },
];

export const GET_GUIDANCE_MENOPAUSE_JOURNEY = 356;
export const MODE = {
  VIDEO: "video",
  LIST: "list",
};
export const GET_GUIDANCE_CATEGORIES = [
  {
    catId: 356,
    title: "Menopause Journey",
    enabled: true,
    mode: MODE.LIST,
  },
  {
    catId: 366,
    title: "Taboos",
    enabled: true,
    mode: MODE.VIDEO,
  },
  {
    catId: 371,
    title: "Mind",
    enabled: true,
    mode: MODE.LIST,
  },
  {
    catId: 361,
    title: "Body",
    enabled: true,
    mode: MODE.LIST,
  },
];
export const ARTICLE_CARD_TYPE = {
  LEARN: "LEARN",
  GETGUIDANCE: "GETGUIDANCE",
};

export const COPY_LINK = {
  SUCCESS: "Link copied to clipboard",
  ERROR: "Failed to copy link. Please try again.",
};

export const FEATURES = {
  MAIN: {
    PARA_1: `Your personal menopause app & tracker, 
                  brought to you by the makers of Canesten®, 
                  the UK and Ireland's no.1 selling 
                  women's intimate health brand*.`,
  },
  TRACK: {
    ICON: trackFeature,
    HEADING: "Track your Signs",
    CONTENT:
      "Easily track and monitor your menopause experience, such as hot flushes and night sweats, mood swings or sleep disturbances.",
  },
  LEARN: {
    ICON: learnFeature,
    HEADING: "Learn about Menopause Stages",
    CONTENT:
      "Use our CanesMeno® Guide to learn more about premature menopause, early menopause, perimenopause, menopause and post menopause. Explore relevant articles to learn more and how to equip yourself to navigate this lifestage.",
  },
  INSIGHTS: {
    ICON: gainFeature,
    HEADING: "Gain Insights",
    CONTENT:
      "Gain personal insights into your experiences over time, identify patterns, and understand how changes related to menopause impact your life.",
  },
  COACHING: {
    ICON: coachingFeature,
    HEADING: "Holistic Coaching",
    CONTENT:
      "We've partnered with Karen Heras-Kelly, a renowned feminine empowerment expert and Certified Professional Coach, to guide and support you through the changes of menopause with her “M-Powerment” programme.",
  },
};

export const GIGYA_CONFIG = {
  SCRIPT: `https://cdns.gigya.com/js/gigya.js?apikey=${import.meta.env.VITE_GIGYA_API_KEY}`,
  DEFAULT_LANG: "en",
  SCRIPT_ID: "gigya-script",
  LOGIN_AND_REGISTRATION: {
    CONTAINER: "gigya-container",
    SCREENSET: "bayer-PasswordlessLogin",
    START_SCREEN: "gigya-passwordless-login-screen",
  },
  LOGIN_AND_REGISTRATION_IOS_SPECIFIC: {
    CONTAINER: "gigya-container",
    SCREENSET: "bayer-PasswordlessLogin-Mobile",
    START_SCREEN: "gigya-passwordless-login-screen",
  },
  FORGOT_PASSWORD: {
    CONTAINER: "gigya-container-forgot-password",
    SCREENSET: "bayer-RegistrationLogin",
    START_SCREEN: "bayer-reset-password-screen",
  },
  CHANGE_PASSWORD: {
    CONTAINER: "gigya-container-change-password",
    SCREENSET: "bayer-ProfileUpdate",
    START_SCREEN: "bayer-change-password-screen",
  },
  SET_NEW_PASSWORD: {
    CONTAINER: "gigya-container-set-new-password",
    SCREENSET: "bayer-RegistrationLogin",
    START_SCREEN: "bayer-forgot-password-loggedin-screen",
  },
};

export const HOME_SLIDER_ITEMS = [
  {
    drupal_internal__nid: 1,
    titie: `Track your menopause signs to gain personal insights.`,
  },
  {
    drupal_internal__nid: 2,
    titie: `Use our CanesMeno® Guide to understand more about the stages of menopause.`,
  },
  {
    drupal_internal__nid: 3,
    titie: `Access Karen-Heras Kelly's <q>M-Powerment</q> Program to help guide you through your menopause transition.`,
  },
];

export const LOGOUT = {
  HEADING: "Do you want to log out?",
  BUTTON_OK: "Confirm",
  BUTTON_CANCEL: "Dismiss",
};

export const ASSESSMENT_COMMON_TEXT = `*The Menopause Quick 6 (MQ6) questionnaire has been adapted and
reproduced with permission from the College of Family Physicians of
Canada from: Goldstein S. An efficient tool for the primary care
management of menopause. Can Fam Physician. 2017 Apr;63(4):295-298`;

export const NOTIFICATION_PERMISSION = {
  GRANTED: "granted",
  DENIED: "denied",
  DEFAULT: "default",
};

export const PROFILE_TEXT = {
  DELETE_ACCOUNT_TEXT:
    "Please note that the deletion of your user account takes a few minutes to complete. If you attempt to create a new account with the same email address in the meantime you may see your old data partially or fully synched back to the new account.",
};

export const VENDOR_DETAILS = {
  AMAZON: "amazon",
  BOOTS: "boots",
};

export const LONG_DESCRIPTION_TITLE = `Learn more why we are asking this`;
export const MIKMAK_IDS = "5010605403866, 5010605403538, 5010605403880";

export const GET_GUIDANCE = {
  MENOPAUSE_HELP_TEXT: `* Please note that the M-Powerment Program and its content is the work of Karen Heras-Kelly and is being provided in collaboration with Karen through the CanesMeno® Hub to support you on your menopause journey.`,
};

export enum bazzarvoiceType {
  summary = "summary",
  reviews = "reviews",
}

export const INDEX_DB = {
  DB_NAME: "CanesMenoDB",
  QUESTIONNAIRES_TABLE: "questionnaires",
  ONBOARDING_PROGRESS_TABLE: "onboardingProgress",
  CONSENTS_TABLE: "consents",
  OUR_CONDITIONS_TABLE: "ourConditions",
  PROFILE_IMAGE_TABLE: "profileImage",
};

export const AUTH_LANDING = {
  LOGIN: {
    title: "Welcome Back!",
    subTitle:
      "It’s wonderful to see you again — Let’s dive back into your menopause journey. ",
    buttonText: "Log in",
    linkText: "Don’t have an account? sign up",
  },
  SIGNUP: {
    title: "Get Started on Your Journey",
    subTitle: "Your journey starts here—sign up now to take the first step.",
    buttonText: "Sign up",
    linkText: "Already have an account? login",
  },
};

export const OUR_CONDITIONS = {
  HEADING: "Our Conditions of Use",
  DESCRIPTION:
    "To continue, please read our Conditions of Use. For any health-related issues or concerns, please always consult a qualified medical professional or doctor.",
  CHECKBOX: {
    type: "checkbox", // Type of input (checkbox in this case)
    id: "ourConditions", // Unique identifier for the consent item
    label: "",
    value: "",
    options: [
      {
        // label: `I have read and understood the <a href="/conditions-of-use">Conditions of Use</a> and acknowledge that the app is not a diagnostic or treatment solution.`, // Description as the label for the checkbox
        label: `<p>I have read and understood the <a href="/conditions-of-use">Conditions of Use</a>  and <a href="/privacy-statement">Privacy Statement</a>, and acknowledge that the app is not a diagnostic or treatment solution.*</p>`, // Description as the label for the checkbox
        value: true, // Consent ID as the value of the checkbox
      },
    ],
    // Validators are added only for mandatory consent
    validators: [
      {
        validatorFunction: required, // Ensures the user selects the option
        message: "You must accept the Conditions of Use", // Error message for missing selection
      },
    ],
  },
};

export const MARKETING_CONSENT = {
  TITLE: "Join the CanesMeno® Community",
  LOGGEDOUT_DESCRIPTION:
    "Enter your email address to receive information about new features and products, education and information on menopause, as well as exclusive offers from CanesMeno®.",
  CHECKBOX_MANDATORY_MESSAGE: "Please select the checkbox to proceed.",
  EMAIL_MANDATORY_MESSAGE: "Please enter a valid email address to proceed.",
  EMAIL_PLACEHOLDER: "Enter your email address",
  CTA_BUTTON_TEXT_LOGGED_IN: "Join Now",
  CTA_BUTTON_TEXT_LOGGED_OUT: "Sign Up",
  SUCCESS_TITLE: "Thank You for Joining Our Community!",
  FOOTER: {
    TEXT: "For more details, please see our ",
    LINK_TEXT: "Privacy Statement.",
  },
};

export const MARKETING_CONSENT_EXPIRY_IN_MILLISECONDS = {
  LOGGED_IN_USER: 14 * 24 * 60 * 60 * 1000, // 14 days
  LOGGED_OUT_USER: 180 * 24 * 60 * 60 * 1000, // 180 days
  LOGGED_OUT_USER_MODAL_CLOSE: 1 * 24 * 60 * 60 * 1000, // 1 day
  SIGNOUT_COOKIE: 1 * 24 * 60 * 60 * 1000, // 1 day
};

export const MARKETING_CONSENT_POPUP_DELAY = 30000; // Delay in milliseconds before showing the modal for logged out users
export const MARKETING_CONSENT_MODAL_ID = "marketingConsentModal";
export const MARKETING_CONSENT_STATUS = {
  ACTIVE: "ACTIVE",
  WITHDRAWN: "WITHDRAWN",
};
export const PLATFORM = {
  IOS: "ios",
  ANDROID: "android",
  WEB: "web",
} as const;

export type Platform = (typeof PLATFORM)[keyof typeof PLATFORM];

export const WELCOME_OFFER = {
  TITLE: "Welcome Offer",
  DESCRIPTION: {
    PART_1: "Sign up",
    PART_2: "now",
    PART_3: "and get a",
    PART_4: "£5 Boots voucher",
    PART_5: "for our CanesMeno product range",
  },
  ACTIONS: {
    SUBMIT: "sign up and claim",
    CLOSE: "maybe later",
  },
  VOUCHER: {
    TITLE: "Your Welcome Offer",
    DESCRIPTION: {
      PART_1: "Here is your",
      PART_2: "£5 Boots voucher",
      PART_3: "to try our CanesMeno product range",
    },
    COPY_CODE: "Copy Code",
    COPIED: "Copied!",
    EMAIL_SENT: "We've also sent this voucher to",
    TERMS_AND_CONDITIONS: "Terms and Conditions",
    TERMS: {
      ITEM_1:
        "Valid on CanesMeno Night, Multi Support, Hydration and Comfort Gel & Energy",
      ITEM_2_PREFIX: "Redeemable in",
      ITEM_2_HIGHLIGHT: "Boots online store",
      ITEM_3: "Input as promo code at check-out",
      DATE_FALLBACK: "xxx",
    },
  },
  MODAL_ID: "voucherModal", // Id for modal, to close modal
  STATUS: {
    OFFER_SHOWN: "offer_shown",
    VOUCHER_SHOWN: "voucher_shown",
  },
  BOOTS_STORE_URL: "https://www.boots.com/",
};
